<template>
  <div class="text-align-left" v-if="this.$store.get('systems@ApiKey')">
    <!-- 
      <h4 class="font-color-primary">
        แพทย์ : {{ this.$store.get("systems@LoginData").userName }}
      </h4> -->
    <b-row v-if="this.PatientWardData">
      <b-col
        class="margin-bottom "
        lg="3"
        v-for="item in PatientWardData"
        v-bind:key="item.id"
      >
        <md-card class="card-custom" md-with-hover>
          <md-card-header>
            <md-card-header-text>
              <div class="md-title">เตียง : {{ item.bedno }}</div>
              <div class="md-title">{{ item.PatientName }}</div>
              <div class="md-subhead">
                AN : {{ item.an }}{{ setPatientImageData(item.hn) }}
              </div>
              <div class="md-subhead">HN : {{ item.hn }}</div>
            </md-card-header-text>

            <md-card-media>
              <div v-if="getImageData(item.hn).length > 0">
                <div
                  :style="{
                    backgroundImage: `url('${getImageData(item.hn)[0].img}')`
                  }"
                  style="background-size:cover;width:80px;height:90px; background-position:top center;"
                  class="img-thumbnail img-fluid"
                ></div>
              </div>
              <div v-if="getImageData(item.hn).length <= 0">
                <div
                  :style="{
                    backgroundImage: `url('')`
                  }"
                  style="background-size:cover;width:80px;height:90px; background-position:top center;"
                  class="img-thumbnail img-fluid"
                ></div>
              </div>
            </md-card-media>
          </md-card-header>

          <md-card-content class="padding-bottom-0px">
            <div class="font14px">Ward : {{ item.ActiveWardName }}</div>
            <div class="font14px">
              วันที่รับ :
              {{ thaiDatetimeFc.ThaiDateTime(item.AdmDateTime) }}
            </div>
            <div
              class="font14px"
              v-if="item.DchDateTime != null && item.DchDateTime != ''"
            >
              จำหน่าย :
              {{ thaiDatetimeFc.ThaiDateTime(item.DchDateTime) }}
            </div>
          </md-card-content>

          <md-card-actions>
            <md-button
              v-show="false"
              class="md-dense md-raised md-accent"
              @click="viewEMR(item.hn)"
              >EMR</md-button
            >

            <b-img
              thumbnail
              rounded="circle"
              :alt="'EMR'"
              :title="'EMR'"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color:#ffffff;padding:2px;"
              v-bind:src="imgEMRIcon"
              @click="viewEMR(item.hn)"
            ></b-img>

            <md-button
              v-show="false"
              class="md-dense md-raised md-primary"
              @click="setPatientData(item.hn, item.an, item.vn)"
            >
              DC Summary
            </md-button>

            <b-img
              thumbnail
              rounded="circle"
              :alt="'DC Summary'"
              :title="'DC Summary'"
              width="50"
              class="icon-css cursor-pointer margin-right8px"
              style="background-color:#ffffff;padding:2px;"
              v-bind:src="imgDCHSummaryIcon"
              @click="setPatientData(item.hn, item.an, item.vn)"
            ></b-img>

            <!-- 
            <md-button
              class="md-dense md-raised"
              @click="setPatientData(item.hn, item.an, item.vn)"
            >
              Coding
            </md-button> 
            -->
          </md-card-actions>
        </md-card>
        <!--
        <b-card
          img-top
          bg-variant="light"
          text-variant="dark"
          tag="article"
          class="cursor-pointer"
          @click="setPatientData(item.hn, item.an, item.vn)"
        >
          <b-card-text>
            <div v-if="getImageData(item.hn).length > 0">
              <div
                :style="{
                  backgroundImage: `url('${getImageData(item.hn)[0].img}')`
                }"
                style="background-size:cover;width:110px;height:130px; background-position:top center;"
                class="img-thumbnail img-fluid"
              ></div>
            </div>
            <div v-if="getImageData(item.hn).length <= 0">
              <div
                :style="{
                  backgroundImage: `url('')`
                }"
                style="background-size:cover;width:110px;height:130px; background-position:top center;"
                class="img-thumbnail img-fluid"
              ></div>
            </div>
            <div class="font18px font-color-primary">
              เตียง : {{ item.bedno }}
            </div>
            <div class="font14px">
              AN : {{ item.an }}{{ setPatientImageData(item.hn) }}
            </div>
            <div class="font14px">HN : {{ item.hn }}</div>
            <div class="font14px font-color-primary">
              ชื่อ : {{ item.PatientName }}
            </div>
            <div class="font14px">Ward : {{ item.ActiveWardName }}</div>
            <div class="font14px">
              วันที่รับ :
              {{ thaiDatetimeFc.ThaiDateTime(item.AdmDateTime) }}
            </div>
            <div
              class="font14px"
              v-if="item.DchDateTime != null && item.DchDateTime != ''"
            >
              จำหน่าย :
              {{ thaiDatetimeFc.ThaiDateTime(item.DchDateTime) }}
            </div>
          </b-card-text>
        </b-card> -->
      </b-col>
    </b-row>

    <div>
      <b-modal
        id="modal-admit-data"
        title="ประวัติ Admit"
        size="xl"
        hide-footer
        button-size="sm"
        :no-close-on-backdrop="true"
        :close-on-esc="true"
      >
        <EmrAdmitData
          v-bind:my-vn="this.selectVN"
          v-bind:my-hn="this.selectHN"
          v-bind:my-an="this.selectAN"
        ></EmrAdmitData>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import axios from "axios";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import EmrAdmitData from "@/components/PatientEMR/EmrAdmitData";
import PatientData from "@/models/patientEMRs/PatientData";
import PatientLabHead from "@/models/patientEMRs/PatientLabHead";
import PatientXrayHead from "@/models/patientEMRs/PatientXrayHead";

const DCHSummaryIcon = require("@/images/DCHSummary77-512.png");
const EMRIcon = require("@/images/EMR16-512.png");

@Component({
  component: {
    store,
    axios,
    thaiDatetime,
    pjFunctions,
    EmrAdmitData,
    PatientLabHead,
    PatientXrayHead
  },
  props: ["SelectWard", "SelectDoctor", "DchStatus"],
  data() {
    return {
      imgData: [],
      imgDataList: [],
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        }
      },
      sortBy: "numbers",
      sortDesc: true,
      PatientWardData: [],
      sWard: "",
      sDoctor: "",
      selectHN: "",
      selectAN: "",
      selectVN: "",
      selectStatus: true,
      imgDCHSummaryIcon: DCHSummaryIcon,
      imgEMRIcon: EMRIcon
    };
  },
  mounted() {
    this.sWard = this.SelectWard;
    this.sDoctor = this.SelectDoctor;
    this.sDchStatus = this.DchStatus;
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {
    sWard: function() {
      this.setDoctorPatientWardData(
        this.SelectWard,
        this.SelectDoctor,
        this.DchStatus
      );
    },
    sDoctor: function() {
      this.setDoctorPatientWardData(
        this.SelectWard,
        this.SelectDoctor,
        this.DchStatus
      );
    },
    DchStatus: function() {
      this.setDoctorPatientWardData(
        this.SelectWard,
        this.SelectDoctor,
        this.DchStatus
      );
    }
  },
  methods: {
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    setDoctorPatientWardData(ward, doctor, dchStatus) {
      let formData = new FormData();
      formData.append("CompanyId", this.$store.get("systems@CompanyId"));
      formData.append("ApiKey", this.$store.get("systems@ApiKey"));
      formData.append("Ward", ward);
      formData.append("DoctorCode", doctor);
      formData.append("dchStatus", dchStatus);

      let data = [];
      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EnquireIPDDoctor", formData)
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            ScrObj.PatientWardData = ScrObj.output.result;
          } else {
            ScrObj.PatientWardData = [];
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          ScrObj.PatientWardData = [];
          console.log("EnquireIPDDoctorSumWard : " + ScrObj.output);
        });
    },
    setPatientData(hn, an, vn) {
      this.selectStatus = false;

      // Load Patient Data
      let currentObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "PatientData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn
        })
        .then(function(response) {
          currentObj.output = response.data;
          if (currentObj.output.status === true) {
            PatientData.insertOrUpdate({
              data: {
                id: currentObj.output.result.hn,
                hn: currentObj.output.result.hn,
                datas: currentObj.output.result
              }
            });
          }
        })
        .catch(function(error) {
          currentObj.output = error;
          console.log("PatientData : " + currentObj.output);
        })
        .finally(function() {
          currentObj.setLabData(hn, an);
        });
    },
    setLabData(hn, an, vn) {
      // Load Lab Data
      let data = [];
      let LabHeadObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "LabHeadData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          an: an,
          department: "IPD"
        })
        .then(function(response) {
          LabHeadObj.output = response.data;
          if (LabHeadObj.output.status === true) {
            PatientLabHead.delete({
              where(record) {
                return record.hn == hn;
              }
            });

            data = [];
            let dtID = 0;
            for (var val of LabHeadObj.output.result) {
              if (
                val.order_date != "" &&
                val.order_date != "null" &&
                val.order_date != null &&
                val.order_time != "" &&
                val.order_time != "null" &&
                val.order_time != null
              ) {
                dtID = LabHeadObj.thaiDatetimeFc.DateTimeId(
                  val.order_date + " " + val.order_time
                );
              }

              data.push({
                id: val.lab_order_number,
                lab_order_number: val.lab_order_number,
                hn: val.hn,
                vn: val.vn,
                an: val.an,
                department: val.department,
                datas: val,
                list_orderby: dtID
              });
            }

            PatientLabHead.insertOrUpdate({
              data
            });
          } else {
            if (LabHeadObj.output.ErrorMessage === "Data Not Found") {
              PatientLabHead.delete({
                where(record) {
                  return record.hn == hn;
                }
              });
            }
          }
        })
        .catch(function(error) {
          LabHeadObj.output = error;
          console.log("LabHeadData : " + LabHeadObj.output);
        })
        .finally(function() {
          LabHeadObj.setXrayData(hn, an);
          //LOAD LabHeadObj.loadXrayData(hn, vn);
        });
    },
    setXrayData(hn, an, vn) {
      // Load Xray Data
      let data = [];
      let XrayHeadObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "XrayHeadData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          an: an,
          department: "IPD"
        })
        .then(function(response) {
          XrayHeadObj.output = response.data;
          if (XrayHeadObj.output.status === true) {
            PatientXrayHead.delete({
              where(record) {
                return record.hn == hn;
              }
            });

            data = [];
            for (var val of XrayHeadObj.output.result) {
              data.push({
                id: val.vn,
                xray_order_number: val.xray_order_number,
                hn: val.hn,
                vn: val.vn,
                an: val.an,
                department: val.department,
                datas: val
              });
            }

            PatientXrayHead.insertOrUpdate({
              data
            });
          } else {
            if (XrayHeadObj.output.ErrorMessage === "Data Not Found") {
              PatientXrayHead.delete({
                where(record) {
                  return record.hn == hn;
                }
              });
            }
          }
        })
        .catch(function(error) {
          XrayHeadObj.output = error;
          console.log("XrayHeadData : " + XrayHeadObj.output);
        })
        .finally(function() {
          XrayHeadObj.selectAdmitData(hn, an, vn);
          // XrayHeadObj.XrayHeadLoadSTD = true;
          // LOAD XrayHeadObj.loadAppointmentData(hn, vn);
        });
    },
    setPatientImageData(hn) {
      let imgFull = "";
      let currentObj = this;

      let checkImg = currentObj.imgData.filter(item => {
        return item.hn == hn;
      });

      let checkImgList = currentObj.imgDataList.filter(item => {
        return item.hn == hn;
      });

      if (checkImgList.length <= 0) {
        currentObj.imgDataList.push({ hn: hn, status: "Y" });

        this.axios
          .post(this.$store.get("systems@UrlApi") + "PatientImage", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn
          })
          .then(function(response) {
            currentObj.output = response.data;
            if (currentObj.output.status === true) {
              let img = currentObj.output.result.patient_image;

              imgFull = "data:image/png;base64," + img;
              if (img != "") {
                imgFull = "data:image/png;base64," + img;
              } else {
                imgFull = "";
              }

              let cc = currentObj.imgData.filter(item => {
                return item.hn == hn;
              });

              if (cc.length <= 0) {
                currentObj.imgData.push({ hn: hn, img: imgFull });
              }
            } else {
              let cc = currentObj.imgData.filter(item => {
                return item.hn == hn;
              });

              if (cc.length <= 0) {
                currentObj.imgData.push({ hn: hn, img: "" });
              }
            }
          })
          .catch(function(error) {
            currentObj.output = error;
            console.log("PatientImage : " + currentObj.output);
          });
      }
    },
    getImageData(hn) {
      let cc = this.imgData.filter(item => {
        return item.hn == hn;
      });

      return cc;
    },
    selectAdmitData(hn, an, vn) {
      this.selectHN = hn;
      this.selectAN = an;
      this.selectVN = vn;
      this.selectStatus = true;
      setTimeout(() => {
        this.$bvModal.show("modal-admit-data");
      }, 500);
    },
    viewEMR(hn) {
      store.set("systems@SearchPT", true);
      store.set("systems@SearchPTid", hn);

      this.$router.push({
        path: "/PatientEMR/" + hn
      });
    }
  }
})
export default class DoctorPatientWard extends Vue {}
</script>


<style lang="scss">
</style>
